import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Button, Input, Card, CardHeader, CardTitle, CardDescription, CardContent, useToast } from '@lancar-pos/ui';
import { useAuthStore } from '../../lib/auth';

export function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { updatePassword } = useAuthStore();
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Kata sandi tidak cocok', 'Pastikan kedua kata sandi sama');
      return;
    }

    if (password.length < 8) {
      toast.error('Kata sandi terlalu pendek', 'Minimal 8 karakter');
      return;
    }

    setLoading(true);
    const { error } = await updatePassword(password);
    setLoading(false);

    if (error) {
      toast.error('Gagal mengubah kata sandi', error.message);
    } else {
      toast.success('Kata sandi berhasil diubah');
      navigate({ to: '/app' });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Reset Kata Sandi</CardTitle>
          <CardDescription>
            Buat kata sandi baru untuk akun Anda
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="password"
              label="Kata Sandi Baru"
              placeholder="Minimal 8 karakter"
              value={password}
              onChange={setPassword}
              required
            />
            <Input
              type="password"
              label="Konfirmasi Kata Sandi"
              placeholder="Ulangi kata sandi"
              value={confirmPassword}
              onChange={setConfirmPassword}
              required
            />
            <Button type="submit" loading={loading} fullWidth>
              Simpan Kata Sandi Baru
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
